// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-modal-settings{
    row-gap: 0.4em;
    padding: 0em 0.2em 0.8em 0.8em;
    border-bottom: 1px solid var(--line-color);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

.header-modal-settings p{
    font-size: 1.2em;
    font-weight: light;
}

.body-modal-settings{
    font-size: 0.85em;
    padding: 0em; 
    background-color: var(--white-smoke);

    display: flex;
    flex-direction: column;
    justify-content: center;
    row-gap: 0.5em;
    column-gap: 5em;
}

.body-modal-settings ul{
    margin-top: 1em;
    text-align: start;
}

.body-modal-settings ul li{
    list-style: none;
}

.footer-modal-settings{
    padding-top: 1.4em;
    border-top: 1px solid var(--line-color);

    display: flex;
    justify-content: center;
    column-gap: 1em;
}

/* Modal Put */

.body-modal-settings .container-put-form,
.body-modal-settings .container-put-permissions-form{
    width: 100%;
    font-size: 1.08em;
    padding: 1.8em 6em 1.8em;
    border-bottom: 1px solid var(--line-color);
    background-color: inherit;
    
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 2em;
}

.body-modal-settings .container-put-permissions-form{
    padding: 1.4em 6em 1.8em;
}

.container-put-form .put-form{
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1.8em 4em;
}

.container-put-permissions-form .put-permissions-form{
    width: 100%;
    display: flex;
    justify-content: space-between;
}

.body-modal-settings .container-data-info{
    width: 100%;
    font-size: 0.95em;
    padding: 1.8em 0.8em;
    background-color: inherit;
    
    display: flex;
    justify-content: center;
    align-items: center;
    column-gap: 4em;
}

/* Modal Ref */

.body-modal-settings .container-filter{
    padding: 2em 3em 1em;
}

.body-modal-settings .noresults-ref{
    font-style: italic;
    padding: 1em 4em;
}

.body-modal-settings .container-ref-table{
    width: 100%;
    padding: 0em 3em;
    max-height: 480px;
    overflow: auto;
} 

.body-modal-settings .ref-table{
    width: 100%;
    font-size: 0.96em;
}

.ref-table th, .ref-table td{
    text-align: start;
    padding: 0.6em 0em 0.6em 1.2em;
    border-bottom: 1px solid var(--black);  
}

.ref-table th{
    background-color: var(--white);
    position: sticky;
    top: 0px;
    z-index: 1;
}

.ref-table td{
    max-height: 4em;
    padding: 1.2em 0 1.2em 1.2em;
    border-bottom: 1px solid var(--line-color-light);
    color: var(--grey);
    background-color: var(--white);
}

.ref-table tr.bg-dif td{
    background-color: var(--white-smoke);
}

/* Modal Permissions */

.body-modal-settings .container-permissions{
    width: 100%;
    padding: 1.4em 0em 2em;
    border-bottom: 1px solid var(--line-color);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    row-gap: 1.4em;
} 

.container-permissions .header-permission{
    font-size: 1.2em;
    font-weight: bold;
    letter-spacing: 0.8px;
}

.container-permissions .body-permission{
    width: 100%;
    display: flex;
    justify-content: center;
    column-gap: 2.6em;
}

.container-permissions .body-permission .body-item{
    display: flex;
    flex-direction: column;
    align-items: center;
    row-gap: 0.5em;
}

`, "",{"version":3,"sources":["webpack://./src/components/modal/modalSettings/modalCRUD/style.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,8BAA8B;IAC9B,0CAA0C;;IAE1C,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,YAAY;IACZ,oCAAoC;;IAEpC,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;;IAEvC,aAAa;IACb,uBAAuB;IACvB,eAAe;AACnB;;AAEA,cAAc;;AAEd;;IAEI,WAAW;IACX,iBAAiB;IACjB,wBAAwB;IACxB,0CAA0C;IAC1C,yBAAyB;;IAEzB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;IAC9B,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,oBAAoB;IACpB,yBAAyB;;IAEzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA,cAAc;;AAEd;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,qCAAqC;AACzC;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,gDAAgD;IAChD,kBAAkB;IAClB,8BAA8B;AAClC;;AAEA;IACI,oCAAoC;AACxC;;AAEA,sBAAsB;;AAEtB;IACI,WAAW;IACX,sBAAsB;IACtB,0CAA0C;;IAE1C,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,cAAc;AAClB","sourcesContent":[".header-modal-settings{\n    row-gap: 0.4em;\n    padding: 0em 0.2em 0.8em 0.8em;\n    border-bottom: 1px solid var(--line-color);\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n.header-modal-settings p{\n    font-size: 1.2em;\n    font-weight: light;\n}\n\n.body-modal-settings{\n    font-size: 0.85em;\n    padding: 0em; \n    background-color: var(--white-smoke);\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    row-gap: 0.5em;\n    column-gap: 5em;\n}\n\n.body-modal-settings ul{\n    margin-top: 1em;\n    text-align: start;\n}\n\n.body-modal-settings ul li{\n    list-style: none;\n}\n\n.footer-modal-settings{\n    padding-top: 1.4em;\n    border-top: 1px solid var(--line-color);\n\n    display: flex;\n    justify-content: center;\n    column-gap: 1em;\n}\n\n/* Modal Put */\n\n.body-modal-settings .container-put-form,\n.body-modal-settings .container-put-permissions-form{\n    width: 100%;\n    font-size: 1.08em;\n    padding: 1.8em 6em 1.8em;\n    border-bottom: 1px solid var(--line-color);\n    background-color: inherit;\n    \n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    row-gap: 2em;\n}\n\n.body-modal-settings .container-put-permissions-form{\n    padding: 1.4em 6em 1.8em;\n}\n\n.container-put-form .put-form{\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 1.8em 4em;\n}\n\n.container-put-permissions-form .put-permissions-form{\n    width: 100%;\n    display: flex;\n    justify-content: space-between;\n}\n\n.body-modal-settings .container-data-info{\n    width: 100%;\n    font-size: 0.95em;\n    padding: 1.8em 0.8em;\n    background-color: inherit;\n    \n    display: flex;\n    justify-content: center;\n    align-items: center;\n    column-gap: 4em;\n}\n\n/* Modal Ref */\n\n.body-modal-settings .container-filter{\n    padding: 2em 3em 1em;\n}\n\n.body-modal-settings .noresults-ref{\n    font-style: italic;\n    padding: 1em 4em;\n}\n\n.body-modal-settings .container-ref-table{\n    width: 100%;\n    padding: 0em 3em;\n    max-height: 480px;\n    overflow: auto;\n} \n\n.body-modal-settings .ref-table{\n    width: 100%;\n    font-size: 0.96em;\n}\n\n.ref-table th, .ref-table td{\n    text-align: start;\n    padding: 0.6em 0em 0.6em 1.2em;\n    border-bottom: 1px solid var(--black);  \n}\n\n.ref-table th{\n    background-color: var(--white);\n    position: sticky;\n    top: 0px;\n    z-index: 1;\n}\n\n.ref-table td{\n    max-height: 4em;\n    padding: 1.2em 0 1.2em 1.2em;\n    border-bottom: 1px solid var(--line-color-light);\n    color: var(--grey);\n    background-color: var(--white);\n}\n\n.ref-table tr.bg-dif td{\n    background-color: var(--white-smoke);\n}\n\n/* Modal Permissions */\n\n.body-modal-settings .container-permissions{\n    width: 100%;\n    padding: 1.4em 0em 2em;\n    border-bottom: 1px solid var(--line-color);\n\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    row-gap: 1.4em;\n} \n\n.container-permissions .header-permission{\n    font-size: 1.2em;\n    font-weight: bold;\n    letter-spacing: 0.8px;\n}\n\n.container-permissions .body-permission{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    column-gap: 2.6em;\n}\n\n.container-permissions .body-permission .body-item{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    row-gap: 0.5em;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
